export enum ValueSource {
  None = 0,
  OrgTreeNodeId = 1,
  ModelId = 2,
  RiskMatrixId = 3,
  RiskDistributionEnum = 4,
  MitigationDaysEnum = 5,
  OptimizationTypeEnum = 6,
  HierarchyTemplateName = 7,
  PlannedMaintenanceDistributionEnum = 8,
  PlannedMaintenanceImprovements = 9,
  InspectionMonthAndYear = 10,
  HighRiskItems = 11,
  DateRangeStart = 12,
  DateRangeEnd = 13,
}
